import type { Dispatch } from 'redux'
import queryString from 'query-string'
import { Wishlist, nativeAppHeaders } from '@ynap/api-utils'
import { getWatsonConfig, getTimeout } from '@ynap/cart-state/src/selectors/getConfig'
import { redirectToLogin } from '@ynap/redirect-utils'
import { StoreState } from 'app/state/types'
import { ADD_ITEMS_TO_WISHLIST_REQUEST, ADD_ITEMS_TO_WISHLIST_SUCCESS, ADD_ITEMS_TO_WISHLIST_ERROR } from '../constants/ActionTypes'
import wrapFetchWithJSON from './common/wrapFetchWithJSON'
import { getAdditionalCheckoutHeaders } from '../utils/checkoutActionUtils'
import { ShoppingCart } from 'app/types/common-types'

interface State extends StoreState {
    cart: ShoppingCart
}

function addItemsToWishlistRequest() {
    return {
        type: ADD_ITEMS_TO_WISHLIST_REQUEST,
    }
}

function addItemsToWishlistSuccess() {
    return {
        type: ADD_ITEMS_TO_WISHLIST_SUCCESS,
    }
}

function addItemsToWishlistError(error: unknown) {
    return {
        type: ADD_ITEMS_TO_WISHLIST_ERROR,
        error,
    }
}

export default function addItemsToWishlist(partNumbers: { partNumber: string }[], shouldRedirect?: boolean) {
    // shouldRedirect for backward compatible of addItemsToWishlist call in purchase path
    return async (dispatch: Dispatch, getState: () => State, fetch: WindowOrWorkerGlobalScope['fetch']) => {
        const state = getState()
        const { cart: { x_userStatus: userStatus } = {} } = state
        const watsonConfig = getWatsonConfig(state)
        const fetchJSON = wrapFetchWithJSON(fetch, getTimeout(state))
        const additionalHeaders = {
            ...nativeAppHeaders(state.deviceType),
            ...getAdditionalCheckoutHeaders(state),
        }

        dispatch(addItemsToWishlistRequest())
        const RegisteredAndLoggedIn = userStatus === 'R'

        if (!RegisteredAndLoggedIn && shouldRedirect) {
            const partNumbersArr = partNumbers.map((each) => each.partNumber)
            const redirect = `${window.location.pathname}?${queryString.stringify({ partNumbers: partNumbersArr }, { arrayFormat: 'comma' })}`
            return redirectToLogin(state.locale?.id, { redirect })
        }

        try {
            await fetchJSON(Wishlist.addItems({ items: partNumbers, allowExistingItems: true, ...watsonConfig, additionalHeaders }))
            dispatch(addItemsToWishlistSuccess())
        } catch (err: any) {
            const errJson = err.response && (await err.response.clone().json())
            dispatch(addItemsToWishlistError(errJson))
            throw err
        }
    }
}
